module.exports = __webpack_public_path__ + "friend6.png?d2f94b82fc11c5f77df9ddb87e5986c1";


//////////////////
// WEBPACK FOOTER
// ./static/assets/friend6.png
// module id = 479
// module chunks = 0